// src/pages/Privacy.jsx

/**
 * Rechtstexte (AT) – Vorlage.
 * Hinweis: Kein Ersatz für Rechtsberatung. Bitte insbesondere Firmen-/Gewerbedaten,
 * USt/UID-Info, Preis-/Steuerangaben, Produktnamen und Prozessdetails gegenprüfen.
 */

const COMPANY = {
  brand: "ShowKompass",
  name: "Sirus Madjderey",
  address: "Teinfaltstraße 4/B10, 1010 Wien, Österreich",
  phone: "+43 699 176 54 300",
  email: "office@kunstpfeifer.com",
  website: "https://kunstpfeifer.com",
  // Optional – bitte ausfüllen, falls zutreffend:
  // uid: "ATU...",
  // firmenbuch: "FN ...",
  // firmenbuchGericht: "...",
  // gewerbeBehoerde: "Magistratisches Bezirksamt ... / Bezirkshauptmannschaft ...",
  // kammer: "WKO ...",
  // aufsichtsbehoerde: "...",
  // unternehmensgegenstand: "...",
};

const TODAY = "04.01.2026";

export default function Privacy() {
  return (
    <main>
      <section className="container section" aria-labelledby="full-title">
        <h2 id="full-title">Impressum, Datenschutz &amp; AGB</h2>
        <p className="muted">Stand: {TODAY}</p>

        <div className="flow-box" role="group" aria-label="Schnellnavigation">
          <div className="p-card">
            <h3>Inhalt</h3>
            <ul className="muted">
              <li>
                <a href="#impressum">Impressum</a>
              </li>
              <li>
                <a href="#datenschutz">Datenschutzerklärung</a>
              </li>
              <li>
                <a href="#agb">Allgemeine Geschäftsbedingungen (AGB)</a>
              </li>
            </ul>
          </div>
        </div>

        {/* ===================== IMPRESSUM ===================== */}
        <h2 id="impressum" style={{ marginTop: 28 }}>
          Impressum
        </h2>

        <div className="flow-box" role="group" aria-label="Impressum">
          <div role="list" className="flow-col">
            <article className="p-card" role="listitem">
              <h3>1. Anbieter</h3>
              <p>
                <strong>{COMPANY.brand}</strong>
                <br />
                {COMPANY.name}
                <br />
                {COMPANY.address}
                <br />
                Tel: {COMPANY.phone}
                <br />
                E-Mail: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
                <br />
                Website:{" "}
                <a href={COMPANY.website} rel="noopener noreferrer" target="_blank">
                  {COMPANY.website.replace("https://", "")}
                </a>
              </p>
              <p className="muted" style={{ marginTop: 10 }}>
                <strong>Optional/je nach Rechtsform (bitte ergänzen):</strong>
                <br />
                UID-Nr. (falls vorhanden), Firmenbuchnummer/Firmenbuchgericht (falls vorhanden), zuständige
                Gewerbebehörde/Aufsichtsbehörde, Kammerzugehörigkeit (z. B. WKO), Unternehmensgegenstand.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>2. Offenlegung nach Mediengesetz</h3>
              <p className="muted">
                Medieninhaber/in: {COMPANY.name} • Sitz/Wohnort: Wien • Grundlegende Richtung: Information
                über Produkte/Dienstleistungen im Bereich Musik/Creator-Tools &amp; Marketing.
                <br />
                (Bitte die „grundlegende Richtung“/Tätigkeitsbereich an euer tatsächliches Angebot anpassen.)
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>3. Haftung für Inhalte &amp; Links</h3>
              <p className="muted">
                Wir entwickeln die Inhalte dieser Website laufend weiter und bemühen uns, korrekte und aktuelle
                Informationen bereitzustellen. Wir übernehmen jedoch keine Haftung für die Richtigkeit,
                Vollständigkeit und Aktualität sämtlicher Inhalte, insbesondere solcher, die von Dritten
                bereitgestellt wurden.
              </p>
              <p className="muted">
                Unsere Website enthält Links zu externen Websites. Für die Inhalte externer Websites übernehmen
                wir keine Haftung. Für verlinkte Seiten waren zum Zeitpunkt der Verlinkung keine
                Rechtsverstöße erkennbar.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>4. Urheberrecht</h3>
              <p className="muted">
                Inhalte dieser Website (Texte, Grafiken, Logos, UI) unterliegen dem Urheberrecht. Jede
                Verwendung außerhalb der Grenzen des Urheberrechts bedarf unserer vorherigen schriftlichen
                Zustimmung.
              </p>
            </article>
          </div>
        </div>

        {/* ===================== DATENSCHUTZ ===================== */}
        <h2 id="datenschutz" style={{ marginTop: 28 }}>
          Datenschutzerklärung
        </h2>

        <div className="flow-box" role="group" aria-label="Datenschutzerklärung">
          <div role="list" className="flow-col">
            <article className="p-card" role="listitem">
              <h3>1. Verantwortlicher</h3>
              <p>
                <strong>{COMPANY.brand}</strong>
                <br />
                {COMPANY.name}
                <br />
                {COMPANY.address}
                <br />
                Tel: {COMPANY.phone}
                <br />
                E-Mail: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>2. Überblick: Zwecke &amp; Rechtsgrundlagen</h3>
              <ul className="muted">
                <li>
                  <strong>Website-Betrieb, Sicherheit, Fehleranalyse</strong> (Art. 6 Abs. 1 lit. f DSGVO –
                  berechtigtes Interesse).
                </li>
                <li>
                  <strong>Kontaktanfragen</strong> (Art. 6 Abs. 1 lit. b DSGVO – (vor)vertraglich bzw. Art. 6
                  Abs. 1 lit. f DSGVO – effiziente Bearbeitung).
                </li>
                <li>
                  <strong>Newsletter/Marketing</strong> (Art. 6 Abs. 1 lit. a DSGVO – Einwilligung).
                </li>
                <li>
                  <strong>Vertragsabwicklung (z. B. Kauf digitaler Leistungen)</strong> (Art. 6 Abs. 1 lit. b
                  DSGVO).
                </li>
                <li>
                  <strong>Aufbewahrung von Rechnungs-/Buchhaltungsunterlagen</strong> (Art. 6 Abs. 1 lit. c
                  DSGVO – rechtliche Verpflichtung).
                </li>
              </ul>
            </article>

            <article className="p-card" role="listitem">
              <h3>3. Server-Logfiles</h3>
              <p className="muted">
                Beim Besuch der Website verarbeitet unser Hosting-Provider technische Zugriffsdaten
                (z.&nbsp;B. IP-Adresse, Datum/Uhrzeit, angeforderte Seite, Referrer, User-Agent) zur
                Bereitstellung und Absicherung der Website (z.&nbsp;B. Abwehr von Angriffen). Eine
                Zusammenführung mit anderen Daten erfolgt grundsätzlich nicht.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>4. Kontaktaufnahme</h3>
              <p className="muted">
                Wenn du uns per E-Mail oder Formular kontaktierst, verarbeiten wir deine angegebenen Daten
                (z.&nbsp;B. Name, E-Mail, Nachricht) zur Bearbeitung der Anfrage und für Anschlussfragen.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>5. Newsletter / Lead-Magnet (Mailchimp)</h3>
              <p>
                Für Newsletter/Lead-Magnets (z.&nbsp;B. „Testzugang“, Updates, Angebote) verwenden wir
                Mailchimp (Intuit). Dabei werden zumindest deine E-Mail-Adresse und ggf. ein Name sowie
                technische Versand-/Öffnungsdaten verarbeitet.
              </p>
              <ul className="muted">
                <li>
                  <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) – Double-Opt-In.
                </li>
                <li>
                  <strong>Widerruf:</strong> jederzeit über den Abmeldelink oder per E-Mail an{" "}
                  <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
                </li>
                <li>
                  <strong>Drittlandtransfer:</strong> Mailchimp kann Daten auch außerhalb der EU/des EWR
                  verarbeiten (insb. USA). Dafür werden geeignete Garantien (z.&nbsp;B.
                  Standardvertragsklauseln) herangezogen.
                </li>
              </ul>
            </article>

            <article className="p-card" role="listitem">
              <h3>6. Zahlungsabwicklung (Stripe)</h3>
              <p className="muted">
                Für den Kauf kostenpflichtiger Leistungen nutzen wir Stripe (Stripe Payments Europe, Ltd.,
                Dublin/Irland). Stripe verarbeitet Zahlungsdaten (z.&nbsp;B. Zahlungsmethode, Transaktions-
                und Gerätedaten) zur Abwicklung der Zahlung und Betrugsprävention. Wir erhalten von Stripe
                in der Regel nur Transaktions- und Bestätigungsinformationen (keine vollständigen
                Kartendaten).
              </p>
              <p className="muted">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie
                ggf. Art. 6 Abs. 1 lit. f DSGVO (Betrugsprävention).
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>7. Aufbewahrung (Rechnungen &amp; Buchhaltung)</h3>
              <p className="muted">
                Vertrags- und Zahlungsdaten können wir zur Erfüllung gesetzlicher Aufbewahrungs- und
                Nachweispflichten speichern (z.&nbsp;B. Buchhaltungsunterlagen/Belege). In Österreich beträgt
                die Aufbewahrungsfrist typischerweise <strong>7 Jahre</strong>.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>8. Cookies &amp; Einwilligungsverwaltung</h3>
              <p>
                Wir verwenden für bestimmte Funktionen lokale Speicher (z.&nbsp;B. LocalStorage) und – je nach
                Einstellung – Cookies/ähnliche Technologien. Notwendige Speicherungen sind für die
                Grundfunktion der Website erforderlich (z.&nbsp;B. Speichern deiner Cookie-Einstellungen).
              </p>
              <p className="muted">
                Für das Setzen/Auslesen nicht notwendiger Cookies bzw. ähnlicher Identifier auf deinem
                Endgerät holen wir – soweit erforderlich – vorab deine Einwilligung ein (u.&nbsp;a. nach
                §&nbsp;165 Abs.&nbsp;3 TKG 2021).
              </p>
              <p className="muted">
                Wenn du Pro-/Bezahlfunktionen nutzt, kann außerdem ein technischer Zugangsschlüssel (Token)
                lokal gespeichert werden, um die Freischaltung im Browser zu merken.
              </p>
              <p className="muted">
                Nicht notwendige Cookies/Tracking (z.&nbsp;B. Analyse) werden nur gesetzt, wenn du vorher
                ausdrücklich eingewilligt hast. Du kannst deine Einwilligung jederzeit über die Cookie-
                Einstellungen (Banner) widerrufen.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>9. Webanalyse (PostHog)</h3>
              <p>
                Wir verwenden <strong>PostHog</strong> (Cloud EU, <code>eu.posthog.com</code>) zur Analyse und
                Verbesserung unseres Angebots. PostHog
                kann hierfür (je nach Konfiguration) Cookies/Identifier nutzen und Ereignisse (z.&nbsp;B.
                Seitenaufrufe, Klicks) erfassen.
              </p>
              <ul className="muted">
                <li>
                  <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO iVm Einwilligung in optionale
                  Cookies/Tracking.
                </li>
                <li>
                  <strong>Datenkategorien:</strong> z.&nbsp;B. gekürzte IP (soweit technisch möglich),
                  Browser-/Geräteinfos, Referrer, Event-Daten.
                </li>
                <li>
                  <strong>Speicherdauer:</strong> nach Zweck/technischer Notwendigkeit; wir halten Daten nicht
                  länger als erforderlich.
                </li>
              </ul>
            </article>

            <article className="p-card" role="listitem">
              <h3>10. YouTube-Einbettungen</h3>
              <p className="muted">
                Auf einzelnen Seiten binden wir Videos von YouTube ein (Google). Wir nutzen – soweit
                möglich – den „Privacy Enhanced Mode“ (youtube-nocookie.com). Beim Laden/Abspielen kann
                dennoch eine Verbindung zu Google-Servern hergestellt und es können Cookies gesetzt bzw.
                ähnliche Technologien eingesetzt werden.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>11. Meta Pixel / Conversion Tracking (optional)</h3>
              <p className="muted">
                Falls wir Meta Pixel/Conversions einsetzen (z.&nbsp;B. zur Messung von Käufen oder Kampagnen-
                Performance), werden dabei u.&nbsp;a. Ereignisdaten (z.&nbsp;B. „Purchase“), Geräte-/Browser-
                Informationen und ggf. Online-Identifikatoren verarbeitet. Solches Tracking erfolgt nur
                nach deiner Einwilligung in optionale Cookies/Marketing.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>12. Empfänger / Auftragsverarbeiter</h3>
              <p className="muted">
                Wir setzen Dienstleister ein (z.&nbsp;B. Hosting, Mailchimp, Stripe, PostHog), die Daten in
                unserem Auftrag verarbeiten. Mit diesen bestehen – soweit erforderlich –
                Auftragsverarbeitungsvereinbarungen (Art. 28 DSGVO) und geeignete Garantien für
                Drittlandübermittlungen.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>13. Speicherdauer</h3>
              <p className="muted">
                Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke
                erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Newsletter-Daten
                speichern wir bis zum Widerruf deiner Einwilligung.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>14. Deine Rechte</h3>
              <ul className="muted">
                <li>Auskunft, Berichtigung, Löschung, Einschränkung</li>
                <li>Datenübertragbarkeit</li>
                <li>Widerspruch (bei berechtigten Interessen)</li>
                <li>Widerruf von Einwilligungen (ohne Nachteile für die Vergangenheit)</li>
                <li>Beschwerde bei der Datenschutzbehörde</li>
              </ul>
              <p className="muted">
                Zuständige Aufsichtsbehörde in Österreich: Datenschutzbehörde (DSB).
              </p>
            </article>
          </div>
        </div>

        {/* ===================== AGB ===================== */}
        <h2 id="agb" style={{ marginTop: 28 }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h2>

        <div className="flow-box" role="group" aria-label="AGB">
          <div role="list" className="flow-col">
            <article className="p-card" role="listitem">
              <h3>1. Geltungsbereich</h3>
              <p className="muted">
                Diese AGB gelten für alle Verträge über digitale Produkte/Dienstleistungen, die über{" "}
                <a href={COMPANY.website} rel="noopener noreferrer" target="_blank">
                  {COMPANY.website.replace("https://", "")}
                </a>{" "}
                oder zugehörige Bestellstrecken abgeschlossen werden.
              </p>
              <p className="muted">
                Verbraucher:in ist, wer ein Geschäft zu Zwecken abschließt, die nicht überwiegend der
                gewerblichen oder selbständigen beruflichen Tätigkeit zugerechnet werden können.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>2. Leistungen</h3>
              <p className="muted">
                Wir bieten digitale Tools/Generatoren, Vorlagen und Inhalte (z.&nbsp;B. Media-Kit-Generator,
                Kurs-/Creator-Tools) als Online-Dienstleistung an. Der konkrete Leistungsumfang ergibt sich
                aus der jeweiligen Produktbeschreibung im Bestellprozess.
              </p>
              <p className="muted">
                Unsere Inhalte und Tools dienen der Information und Unterstützung. Sie stellen keine
                Rechts-, Steuer- oder Finanzberatung dar und ersetzen keine individuelle Beratung. Ein
                bestimmter wirtschaftlicher/marketingbezogener Erfolg wird nicht geschuldet.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>3. Vertragsschluss</h3>
              <p className="muted">
                Die Darstellung von Produkten auf der Website stellt kein rechtlich bindendes Angebot dar,
                sondern eine Aufforderung zur Abgabe einer Bestellung. Der Vertrag kommt zustande, sobald
                die Zahlung erfolgreich abgeschlossen wurde und wir die Bestellung bestätigen bzw. den
                Zugang freischalten.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>4. Preise &amp; Zahlung</h3>
              <p className="muted">
                Preise werden im Bestellprozess angezeigt (in EUR). Die Zahlungsabwicklung erfolgt über
                Stripe. Etwaige Transaktionsgebühren deiner Bank/deines Zahlungsdienstleisters trägst du.
              </p>
              <p className="muted">
                <strong>Umsatzsteuer-Hinweis:</strong> Bitte ergänzen, ob Preise inkl. USt ausgewiesen werden
                bzw. ob eine Kleinunternehmerregelung zur Anwendung kommt.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>5. Bereitstellung digitaler Inhalte</h3>
              <p className="muted">
                Nach erfolgreicher Zahlung erhältst du Zugang zu den digitalen Inhalten/Features
                (z.&nbsp;B. per Bestätigungsseite, Link oder E-Mail). Du bist dafür verantwortlich, dass deine
                E-Mail-Adresse korrekt ist und der Zugriff auf dein Postfach möglich ist.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>6. Nutzungsrechte</h3>
              <p className="muted">
                Wir räumen dir ein einfaches, nicht übertragbares, widerrufliches Nutzungsrecht für die Dauer
                des Vertrags zur eigenen Nutzung ein. Eine Weitergabe, öffentliche Zugänglichmachung oder
                kommerzielle Nutzung über den vereinbarten Zweck hinaus (z.&nbsp;B. Weiterverkauf, „Sharing“
                von Zugängen) ist ohne unsere Zustimmung nicht erlaubt.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>7. Verfügbarkeit &amp; Änderungen</h3>
              <p className="muted">
                Wir bemühen uns um eine möglichst hohe Verfügbarkeit, können aber keine unterbrechungsfreie
                Nutzung garantieren (Wartung, Updates, Störungen). Wir dürfen Funktionen weiterentwickeln
                und anpassen, sofern der Vertragszweck dadurch nicht wesentlich beeinträchtigt wird.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>8. Gewährleistung</h3>
              <p className="muted">
                Es gelten die gesetzlichen Gewährleistungsrechte. Für Verbraucher:innen sind gesetzliche
                Rechte grundsätzlich zwingend und können nicht ausgeschlossen werden.
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>9. Haftung</h3>
              <p className="muted">
                Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leib,
                Leben oder Gesundheit. Bei leichter Fahrlässigkeit haften wir – soweit gesetzlich zulässig –
                nur bei Verletzung wesentlicher Vertragspflichten und beschränkt auf den typischerweise
                vorhersehbaren Schaden.
              </p>
              <p className="muted">Zwingende Haftungsregeln (insbesondere im Verbraucherrecht) bleiben unberührt.</p>
            </article>

            <article className="p-card" role="listitem">
              <h3>10. Rücktrittsrecht (Verbraucher)</h3>
              <p className="muted">
                Verbraucher:innen steht bei Fernabsatzverträgen grundsätzlich ein Rücktrittsrecht von 14 Tagen
                zu. Details (Fristbeginn, Ausübung, Folgen) richten sich nach dem Fern- und
                Auswärtsgeschäfte-Gesetz (FAGG).
              </p>
              <p className="muted">
                <strong>Hinweis zu digitalen Inhalten:</strong> Das Rücktrittsrecht kann bei digitalen Inhalten,
                die nicht auf einem körperlichen Datenträger geliefert werden, vorzeitig erlöschen, wenn du
                ausdrücklich zustimmst, dass wir vor Ablauf der Rücktrittsfrist mit der Vertragserfüllung
                beginnen, und du zur Kenntnis nimmst, dass du dadurch dein Rücktrittsrecht verlierst. (Sofern
                im Bestellprozess entsprechend vorgesehen.)
              </p>
              <p className="muted">
                <strong>Muster-Rücktrittserklärung:</strong>
                <br />
                An: {COMPANY.name}, {COMPANY.address}, E-Mail: {COMPANY.email}
                <br />
                Hiermit trete ich vom Vertrag über den Kauf der folgenden digitalen Leistung zurück:
                <br />
                Bestellt am: ____ / erhalten am: ____
                <br />
                Name: ____ • Anschrift: ____ • Datum/Unterschrift (bei Brief): ____
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>11. Alternative Streitbeilegung</h3>
              <p className="muted">
                Wir sind nicht verpflichtet, an einem Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen, erklären uns aber bereit, im Einzelfall eine
                außergerichtliche Lösung zu prüfen.
              </p>
              <p className="muted">
                Zuständige österreichische AS-Stellen können z.&nbsp;B. sein: „Internet Ombudsstelle“
                (ombudsstelle.at) bzw. „Schlichtung für Verbrauchergeschäfte“ (verbraucherschlichtung.at).
              </p>
            </article>

            <article className="p-card" role="listitem">
              <h3>12. Schlussbestimmungen</h3>
              <p className="muted">
                Es gilt österreichisches Recht unter Ausschluss des UN-Kaufrechts. Für Verbraucher:innen gilt
                diese Rechtswahl nur insoweit, als dadurch keine zwingenden Bestimmungen des Rechts des
                gewöhnlichen Aufenthaltsstaats entzogen werden.
              </p>
              <p className="muted">
                Gerichtsstand für Unternehmer:innen ist Wien, sofern nicht zwingende gesetzliche Bestimmungen
                entgegenstehen.
              </p>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}
